import {combineReducers} from 'redux'
import createManagementAssignmentsEditor from './createUserManagementAssignmentsEditor/reducer'
import createCommonReducer from './common/reducer'
import createWorkAssignmentsTabReducer from './workAssignmentsTab/reducer'
import workAssignmentsPanel from "./workAssignmentPanel/reducer"
import workAssignmentsEditor from './workAssignmentsEditor/reducer'
import editManagementAssignmentsPanel from './editManagementAssignmentsPanel/reducer'
import createManagementAssignmentsPanel from './createManagementAssignmentsPanel/reducer'
import editManagementAssignmentsEditor from './managementAssignmentsEditor/reducer'
import editTeamAssignmentsPanel from '../../panels/user/editTeamAssignmentsPanel/reducer'
import createTeamAssignmentsPanel from '../../panels/user/createTeamAssignmentsPanel/reducer'

const userManagement = (initAppData) => combineReducers({
    common: createCommonReducer(initAppData),
    workAssignmentsPanel,
    workAssignmentsEditor,
    editManagementAssignmentsPanel,
    createManagementAssignmentsPanel,
    editManagementAssignmentsEditor,
    createManagementAssignmentsEditor,
    editTeamAssignmentsPanel,
    createTeamAssignmentsPanel,
    workAssignmentsTab: createWorkAssignmentsTabReducer(initAppData),
})

export default userManagement



// WEBPACK FOOTER //
// ./web/js/administration/userManagement/reducer.js